"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpecificListsNotMarkedDescription = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.SpecificListsNotMarkedDescription = {
    priority: 2,
    label: 'fields.payload.mor_group_answers.specific_lists_not_marked_description.label',
    fallbackLabel: 'Please provide an explanation as to why the UN List, the EU List and/or the OFAC List are not (fully) used (if you use all of these lists, please enter \'N/A\').',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['contract_onboarding_type'],
    type: Field_type_1.FieldType.String,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
